module.exports = __webpack_public_path__ + "img/apay_white.6f184c7e.svg";